import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home/Home.vue";

/*解决重复进入路由时报错*/
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      /*风险名单过滤*/
      path: "/RiskListFiltering",
      name: "RiskListFiltering",
      component: () => import("./views/RiskListFiltering/RiskListFiltering.vue")
    },
    {
      /*风险预警报告*/
      path: "/riskWarningReport",
      name: "riskWarningReport",
      component: () => import("./views/riskWarningReport/riskWarningReport.vue")
    },
    {
      /*个性化工具订阅*/
      path: "/toolSubscription",
      name: "toolSubscription",
      component: () => import("./views/toolSubscription/toolSubscription.vue")
    },
    {
      /*信息核验*/
      path: "/InformationCheck",
      name: "InformationCheck",
      component: () => import("./views/InformationCheck/InformationCheck.vue"),
      children: [
        {
          path: "/InformationApiDocument",
          name: "InformationApiDocument",
          component: () =>
            import("./views/InformationCheck/components/apiDocument.vue")
        },
        {
          path: "/InformationErrorCode",
          name: "InformationErrorCode",
          component: () =>
            import("./views/InformationCheck/components/errorCode.vue")
        },
        {
          path: "/InformationExampleCode",
          name: "InformationExampleCode",
          component: () =>
            import("./views/InformationCheck/components/exampleCode.vue")
        }
      ]
    },
    {
      /*人脸识别*/
      path: "/faceRecognition",
      name: "faceRecognition",
      component: () => import("./views/faceRecognition/faceRecognition.vue"),
      children: [
        {
          path: "/faceApiDocument",
          name: "faceApiDocument",
          component: () =>
            import("./views/faceRecognition/components/apiDocument.vue")
        },
        {
          path: "/faceErrorCode",
          name: "faceErrorCode",
          component: () =>
            import("./views/faceRecognition/components/errorCode.vue")
        },
        {
          path: "/faceExampleCode",
          name: "faceExampleCode",
          component: () =>
            import("./views/faceRecognition/components/exampleCode.vue")
        }
      ]
    },
    {
      /*核心能力*/
      path: "/coreCompetence",
      name: "coreCompetence",
      component: () => import("./views/coreCompetence/coreCompetence.vue")
    },
    {
      /*因子服务*/
      path: "/factorServices",
      name: "factorServices",
      component: () => import("./views/factorServices/factorServices.vue")
    },
    {
      /*模型工厂*/
      path: "/modelFactory",
      name: "modelFactory",
      component: () => import("./views/modelFactory/modelFactory.vue")
    },
    {
      /*智能标签*/
      path: "/smartLabel",
      name: "smartLabel",
      component: () => import("./views/smartLabel/smartLabel.vue")
    },
    {
      /*大数据操作系统设计*/
      path: "/bigDataOperating",
      name: "bigDataOperating",
      component: () => import("./views/bigDataOperating/bigDataOperating.vue")
    },
    {
      /*企业资源与效率优化*/
      path: "/optimizeEnterprise",
      name: "optimizeEnterprise",
      component: () =>
        import("./views/optimizeEnterprise/optimizeEnterprise.vue")
    },
    {
      /*智能客群洞察系统*/
      path: "/znkqdcSystem",
      name: "znkqdcSystem",
      component: () => import("./views/znkqdcSystem/znkqdcSystem.vue")
    },
    {
      /*智能营销系统*/
      path: "/znyxSystem",
      name: "znyxSystem",
      component: () => import("./views/znyxSystem/znyxSystem.vue")
    },
    {
      /*FAQ*/
      path: "/FAQ",
      name: "FAQ",
      component: () => import("./views/FAQ/FAQ.vue")
    },
    {
      /*API技术文档*/
      path: "/apiDocument",
      name: "apiDocument",
      component: () => import("./views/" + "apiDocument/apiDocument.vue")
    },
    {
      /*加入我们、关于我们*/
      path: "/aboutAndJoinUs",
      name: "aboutAndJoinUs",
      component: () => import("./views/aboutAndJoinUs/aboutAndJoinUs.vue"),
      children: [
        {
          path: "/joinUs",
          name: "joinUs",
          component: () =>
            import("./views/aboutAndJoinUs/components/joinUs.vue")
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: () =>
            import("./views/aboutAndJoinUs/components/aboutUs.vue")
        }
      ]
    },
    {
      /*隐私政策*/
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: () => import("./views/aboutAndJoinUs/privacyPolicy.vue"),
    },
    {
      /*合作案例*/
      path: "/cooperationCase",
      name: "cooperationCase",
      component: () => import("./views/cooperationCase/cooperationCase.vue")
    },
    {
      /*个性化定制*/
      path: "/autobiography",
      name: "autobiography",
      component: () => import("./views/autobiography/autobiography.vue")
    },
    {
      /*羽拾营销服务中心*/
      path: "/yxCenter",
      name: "yxCenter",
      component: () => import("./views/yxCenter/yxCenter.vue")
    }
  ]
});
